import { useEffect, useState, useRef } from 'react'
import { debounce, elInViewPort } from '../../helpers/searchSpringHelpers'
import { SSCarouselResult } from '../../search-spring/types/types'
import ProductCarousel from '../../product-carousel/components/ProductCarousel'
import { getCarouselProducts, trackProfileOnce } from '../carouselData'

declare global {
  interface Window {
    searchSpringCarouselHeading: string
  }
}

const carouselDataset = document.getElementById('ss-carousel-target')?.dataset
const carouselTag = carouselDataset?.carouselId
const carouselProductId = carouselDataset?.productId
const carouselHeading = window?.searchSpringCarouselHeading || 'Recommended for you'
const sku: string = carouselDataset?.productSeed ?? ''
const profile: string = carouselDataset?.carouselId ?? ''

const CarouselInit = () => {
  const [products, setProducts] = useState<SSCarouselResult[]>([])
  const [error, setError] = useState(false)
  const elRef = useRef(null)

  const trackImpressionWhenVisible = (items: SSCarouselResult[]) => {
    const onScroll = debounce(() => {
      if (!elInViewPort(elRef.current, false)) return

      trackProfileOnce('profile.impression', sku, profile, items)
      window.removeEventListener('scroll', onScroll)
    }, 500)

    window.addEventListener('scroll', onScroll)
  }

  useEffect(() => {
    getCarouselProducts({ profile: carouselTag || '', productId: carouselProductId, limit: '8' })
      .then((items) => {
        setProducts(items)
        trackProfileOnce('profile.render', sku, profile, items)
        trackImpressionWhenVisible(items)
      })
      .catch(() => setError(true))
  }, [])

  if (error) {
    return <div className="text-xl font-bstSpyre mt-4 text-center mx-5">Sorry, There was an error creating our carousels, please try again later.</div>
  }

  return (
    <>
      {products.length > 0 && (
        <div className="py-10 w-full mx-auto md:px-5 md:py-2XL md:flex md:flex-col" ref={elRef}>
          <h2 className="font-bstSpyre text-2xl uppercase text-center mb-LG md:mb-DLG">{carouselHeading}</h2>
          <ProductCarousel
            classSlider="md-max:w-[230px] md:min-h-[500px]"
            classWrap="flex"
            source="searchspring"
            products={products}
            spaceBetween={0}
            slidesPerView="auto"
            profile={profile}
            sku={sku}
            breakpoints={{
              768: { slidesPerView: 3, spaceBetween: 5 },
              1024: { slidesPerView: 4, spaceBetween: 5 }
            }}
          />
        </div>
      )}
    </>
  )
}

export default CarouselInit
